import { useCallback } from 'react';

import { useQuery } from '../hooks';

import { CMS_PAGE_CONTENT_SLOTS } from '../../graphql/cms-queries';

import { CmsHtmlComponent } from '../../types/graphql-types';

type GetContentSlot = {
  (name: string): string;
  (name: string, isList: boolean): string[] | string | undefined;
};

interface Slot {
  cmsComponents: CmsHtmlComponent[];
  name: string;
}

function handleContentFormat(slot: Slot): string;
function handleContentFormat(
  slot: Slot,
  isList: boolean
): string[] | string | undefined;
function handleContentFormat(
  slot,
  isList = false
): string[] | string | undefined {
  if (!slot) return;

  if (isList) {
    return slot.cmsComponents?.reduce((acc, c) => {
      if (typeof c?.html === 'string') {
        acc.push(c.html);
      }
      return acc;
    }, []);
  } else {
    return slot.cmsComponents?.[0]?.html ?? '';
  }
}

function useCmsPageContentSlots(
  contentPageId: string,
  shouldSkipQuery = false
) {
  const { data: cmsData } = useQuery(CMS_PAGE_CONTENT_SLOTS, {
    skip: shouldSkipQuery,
    variables: {
      id: contentPageId
    }
  });

  const { contentSlots } = cmsData?.cms?.page || {};

  const getContentSlot: GetContentSlot = useCallback(
    (name, isList = false) => {
      const matchingSlot = contentSlots?.find(
        contentSlot => contentSlot.name === name
      );

      return handleContentFormat(matchingSlot, isList);
    },
    [contentSlots]
  ) as GetContentSlot;

  const getAllContentSlotsByName = useCallback(
    (): Record<string, string | string[] | undefined> =>
      contentSlots?.reduce((acc, contentSlot) => {
        acc[contentSlot.name] = handleContentFormat(
          contentSlot,
          contentSlot?.cmsComponents?.length > 1
        );
        return acc;
      }, {}),
    [contentSlots]
  );

  return {
    getAllContentSlotsByName,
    getContentSlot
  };
}

export default useCmsPageContentSlots;
